import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import values from 'lodash/values';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';

import { stringSelectSpec, boolCheckboxSpec } from '../../lib/editing-configs';

import BackgroundColor from '../background-color/background-color';
import './vertical-spacer.less';

const spacerMap = {
  'p-8': 'p-8',
  'p-12': 'p-12',
  'p-18': 'p-18',
  'p-24': 'p-24',
  'p-30': 'p-30',
  'p-40': 'p-40',
  'p-60': 'p-60',
};

const spacerMapCurrency = {
  'margin-1': 'margin-1',
  'margin-2': 'margin-2',
  'margin-3': 'margin-3',
  'margin-3-half': 'margin-3-half',
  'margin-4': 'margin-4',
  'margin-5': 'margin-5',
};

const VerticalSpacer = ({
  desktop,
  tablet,
  mobile,
  bgOptions,
  backgroundColor: obsoleteBackgroundColor,
  useCurrencyMargins,
}) => {
  function getBackgroundColorConfig() {
    // For backwards compatibility!
    if (obsoleteBackgroundColor && !bgOptions?.backgroundColor) {
      return { backgroundColor: obsoleteBackgroundColor };
    }
    return bgOptions;
  }

  function getMarginStylesByVersion(viewport) {
    if (useCurrencyMargins) {
      return `${spacerMapCurrency[viewport]}`;
    }
    return `${spacerMap[viewport]}`;
  }

  return (
    <BackgroundColor bgOptions={getBackgroundColorConfig()}>
      {(backgroundColor) => (
        <div
          className={classNames({
            [`${getMarginStylesByVersion(desktop)}-d`]: desktop,
            [`${getMarginStylesByVersion(tablet)}-t`]: tablet,
            [`${getMarginStylesByVersion(mobile)}-m`]: mobile,
          })}
          style={{ backgroundColor }}
        />
      )}
    </BackgroundColor>
  );
};

VerticalSpacer.propTypes = {
  ...BackgroundColor.propTypes,
  desktop: PropTypes.oneOf([
    ...values(spacerMap).concat(values(spacerMapCurrency)),
  ]),
  tablet: PropTypes.oneOf([
    ...values(spacerMap).concat(values(spacerMapCurrency)),
  ]),
  mobile: PropTypes.oneOf([
    ...values(spacerMap).concat(values(spacerMapCurrency)),
  ]),
  useCurrencyMargins: PropTypes.bool,
  children: PropTypes.node,
};

VerticalSpacer.defaultProps = {
  useCurrencyMargins: false,
  children: null,
};

function marginTypeConfig(version) {
  const spacerOptions = [{ label: 'Select one', value: '' }].concat(
    Object.keys(version).map((key) => ({
      label: key,
      value: version[key],
    }))
  );

  return [
    stringSelectSpec('mobile', 'Mobile', spacerOptions, {
      help: 'Mobile height',
    }),
    stringSelectSpec('tablet', 'Tablet', spacerOptions, {
      help: 'Tablet height',
    }),
    stringSelectSpec('desktop', 'Desktop', spacerOptions, {
      help: 'Desktop height',
    }),
  ];
}

VerticalSpacer.getEditingConfig = (componentDocument) => {
  const marginTypeOutput =
    get(componentDocument, 'props.useCurrencyMargins', false) === true
      ? marginTypeConfig(spacerMapCurrency)
      : marginTypeConfig(spacerMap);

  return [
    ...BackgroundColor.getEditingConfig(componentDocument),
    boolCheckboxSpec('useCurrencyMargins', 'Use Currency margins?'),
    ...marginTypeOutput,
  ];
};

export default VerticalSpacer;
